import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';
type ArrowBackFloatingProps = IconComponentBaseProps;

export const ArrowBackFloating = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: ArrowBackFloatingProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <mask
        id="mask0_4476_142147"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4476_142147)">
        <path
          d="M3.07602 5.99999L6.93364 9.85773C7.00739 9.9314 7.04381 10.0195 7.04289 10.1221C7.04189 10.2247 7.00452 10.3128 6.93077 10.3865C6.8571 10.4602 6.76898 10.4971 6.66639 10.4971C6.56381 10.4971 6.47569 10.4602 6.40202 10.3865L2.58077 6.56823C2.50002 6.48748 2.44106 6.39744 2.40389 6.29811C2.36673 6.19869 2.34814 6.09932 2.34814 5.99999C2.34814 5.90065 2.36673 5.80128 2.40389 5.70186C2.44106 5.60253 2.50002 5.51249 2.58077 5.43173L6.40202 1.61061C6.47569 1.53686 6.56431 1.50048 6.66789 1.50148C6.77139 1.5024 6.85998 1.53974 6.93364 1.61349C7.00739 1.68715 7.04427 1.77528 7.04427 1.87786C7.04427 1.98044 7.00739 2.06857 6.93364 2.14224L3.07602 5.99999Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
